import { Base } from "../../schema/types/base";
import { linksOf } from "../../services/cpln";
import { parseLink } from "../../utils/linkParser/linkParser";

// TODO fix typing here
// export interface ImageTableItem extends Image {
export interface ImageTableItem extends Base {
  selfLink: string;
}

interface GetImageTableItemProps {
  link?: string;
  name?: string;
  item?: Base;
}
export function getImageTableItem({ link, name, item }: GetImageTableItemProps): ImageTableItem {
  if (item) {
    const selfLink = linksOf(item).self!;

    return {
      ...item,
      selfLink: selfLink,
    };
  }

  if (link) {
    const { name } = parseLink(link, { useInputCtx: true });

    return {
      kind: "image",
      name: name,
      selfLink: link,
      links: [{ rel: "self", href: link }],
      created: "",
      description: "",
      id: "",
      lastModified: "",
      tags: {},
      version: 1,
    };
  }

  // assume name
  return {
    kind: "image",
    name: name!,
    selfLink: `TODO test if this breaks`,
    links: [],
    created: "",
    description: "",
    id: "",
    lastModified: "",
    tags: {},
    version: 1,
  };
}
